import { Component, OnInit } from '@angular/core';
import { LambdaService } from 'src/app/lambda.service';
import { ThemingService } from 'src/app/theming.service';
import * as XLSX from 'xlsx';

interface PlanActivo {
  firstName: string;
  lastName: string;
  email: string;
  saleId: number;
  plan: string;
}

@Component({
  selector: 'app-active-plans-without-beneficiaries',
  templateUrl: './active-plans-without-beneficiaries.component.html',
  styleUrls: ['./active-plans-without-beneficiaries.component.scss']
})
export class ActivePlansWithoutBeneficiariesComponent implements OnInit {
  
  planesActivos: PlanActivo[] = [];
  totalPlanes: number = 0;
  planesPorTipo: { [key: string]: number } = {};
  loading: boolean = false;
  
  constructor(
    private lambdaService: LambdaService,
    private themingService: ThemingService
  ) { }
  
  ngOnInit(): void {
    this.loadData();
  }

  async loadData(): Promise<void> {
    this.loading = true;
    let data: any = await this.lambdaService.getPlansWithoutBeneficiaries(this.themingService.shopId);
    console.log("Planes sin beneficiarios:", data);
    this.planesActivos = data.data;
    // Aquí reemplaza con tu servicio real
    // this.planesActivos = [
    //   { firstName: 'KAROL', lastName: 'CARRILLO RAMIREZ', email: 'karol.carrilloramirez@bsci.com', saleId: 6411, plan: 'Plan Funerario' },
    //   { firstName: 'CARLOS ALBERTO', lastName: 'MENDEZ RODRIGUEZ', email: 'carlos.mendezrodriguez@bsci.com', saleId: 6421, plan: 'Plan Años Dorados' },
    //   { firstName: 'JOSE DANIEL', lastName: 'ULATE PASCUA', email: 'daniel.ulate@bsci.com', saleId: 6425, plan: 'Plan Años Dorados' },
    //   { firstName: 'LUIS', lastName: 'MORALES AZOFEIFA', email: 'luis.moralesazofeifa@bsci.com', saleId: 6431, plan: 'Plan Años Dorados' },
    //   { firstName: 'MARIANA', lastName: 'QUIROS JIMENEZ', email: 'mariana.quirosjimenez@bsci.com', saleId: 6439, plan: 'Plan Mascoticas' },
    //   { firstName: 'MARIA VANESSA', lastName: 'RAMIREZ AGUILAR', email: 'vanessa.ramirezaguilar@bsci.com', saleId: 6440, plan: 'Prevención Total' },
    //   { firstName: 'JOHN ALBERTO', lastName: 'HERNANDEZ SANCHEZ', email: 'johnalberto.hernandezsanchez@bsci.com', saleId: 6443, plan: 'Plan Mascoticas' },
    //   { firstName: 'MELISSA', lastName: 'CARMONA RAMIREZ', email: 'melissa.carmona@bsci.com', saleId: 6444, plan: 'Plan Años Dorados' },
    //   { firstName: 'SERGIO', lastName: 'ESCALONA RODRIGUEZ', email: 'sergioantonio.escalona@bsci.com', saleId: 6447, plan: 'Plan Años Dorados' },
    //   { firstName: 'MARIA FERNANDA', lastName: 'GUTIERREZ VINDAS', email: 'mariafernanda.gutierrezv@bsci.com', saleId: 6448, plan: 'Plan Años Dorados' },
    //   { firstName: 'TRIANA MARIA', lastName: 'CHAVES BRENES', email: 'trianamaria.chavesbrenes@bsci.com', saleId: 6450, plan: 'Plan Años Dorados' }
    // ];

    this.calcularResumen();
    this.loading = false;
  }

  calcularResumen(): void {
    this.totalPlanes = this.planesActivos.length;
    
    this.planesPorTipo = this.planesActivos.reduce((acc, plan) => {
      acc[plan.plan] = (acc[plan.plan] || 0) + 1;
      return acc;
    }, {} as { [key: string]: number });
  }

  descargarExcel(): void {
    const data = this.planesActivos.map(plan => ({
      'Nombre': plan.firstName,
      'Apellidos': plan.lastName,
      'Correo': plan.email,
      'Sale ID': plan.saleId,
      'Plan': plan.plan
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = { Sheets: { 'Planes Activos': worksheet }, SheetNames: ['Planes Activos'] };
    
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.guardarArchivo(excelBuffer, 'planes_activos_sin_beneficiario');
  }

  private guardarArchivo(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}_${new Date().toISOString().split('T')[0]}.xlsx`;
    link.click();
    window.URL.revokeObjectURL(url);
  }

}
